import { AnyAction } from 'redux';
import { GhlBillingInfo, PensionBillingInfo, MyCpgPods, MyCpgPodsActions, MyCpgPodsState } from './mycpg-pod-models';



const InitialState: MyCpgPodsState =
{
	pods: null,
	podsError: false,
	podsLoaded: false,
	ghlInfo: [],
	ghlInfoError: false,
	ghlInfoLoaded: false,
  pensionInfo: [],
  pensionInfoError: false,
  pensionInfoLoaded: false,
};



export const myCpgPodReducer = (state = InitialState, action: AnyAction): MyCpgPodsState => {

  switch (action.type) {

    case MyCpgPodsActions.SET_MYCPG_PODS:
      return {
        ...state,
        pods: action.payload,
        podsLoaded: true,
      };
    case MyCpgPodsActions.SET_MYCPG_ERROR:
      return {
        ...state,
        podsError: true,
        podsLoaded: true,
      };
    case MyCpgPodsActions.SET_GHL_BILLING_INFO:
      return {
        ...state,
        ghlInfo: action.payload,
        ghlInfoLoaded: true,
      };
    case MyCpgPodsActions.SET_PENSION_BILLING_INFO:
      return {
        ...state,
        pensionInfo: action.payload,
        pensionInfoLoaded: true,
      };
    case MyCpgPodsActions.SET_GHL_BILLING_INFO_ERROR:
      return {
        ...state,
        ghlInfoError: true,
        ghlInfoLoaded: true,
      };
    case MyCpgPodsActions.SET_PENSION_BILLING_INFO_ERROR:
      return {
        ...state,
        pensionInfoError: true,
        pensionInfoLoaded: true,
      };
    default: return state;
  }
};



export const setPods = (pods: MyCpgPods) => {

	return {
		type: MyCpgPodsActions.SET_MYCPG_PODS,
		payload: pods,
	};
};

export const setPodsError = () => {

	return {
		type: MyCpgPodsActions.SET_MYCPG_ERROR,
	};
};

export const setGhlBillingInfo = (ghlInfo: GhlBillingInfo[]) => {

	return {
		type: MyCpgPodsActions.SET_GHL_BILLING_INFO,
		payload: ghlInfo,
	};
};

export const setPensionBillingInfo = (pensionInfo: PensionBillingInfo[]) => {

	return {
		type: MyCpgPodsActions.SET_PENSION_BILLING_INFO,
		payload: pensionInfo,
	};
};

export const setGhlBillingInfoError = () => {

  return {
    type: MyCpgPodsActions.SET_GHL_BILLING_INFO_ERROR,
  };
};

export const setPensionBillingInfoError = () => {

  return {
    type: MyCpgPodsActions.SET_PENSION_BILLING_INFO_ERROR,
  };
};
